function load_catalogue(element) {
  const reward_id = $("#" + element).val();
  const catalogueFieldId = $("#" + element).parents(".sel_reward").next(".sel_catalogue").find("select").attr("id");

  $.ajax({
    url: "/rewards/" + reward_id + "/catalogues/available_catalogues?format=json",
    type: "get",
    data: "",
    success: function(data) {
      $("#" + catalogueFieldId).empty();
      for(var i = 0;i < data.length; i++) {
        $("#" + catalogueFieldId).append("<option value='" + data[i]['id'] + "'>" + data[i]['title'] + "</option>");
      }
    },
    error: function(data) {
      $("#" + catalogueFieldId).empty();
    }
  });
}

$(document).ready(function () {
  $(document).on(
    "change",
    ".sel_reward select",
    function () {
      load_catalogue(this.id, this.value);
    }
  );
});
